import type { Deal } from '@/types'
import { extractApiError } from '@/utils/extractApiError'
import { getFriendlyError } from '@/utils/getFriendlyError'
import { REUNIAO_REQUIRED_FIELD } from '@/utils/dealMeetingSchedule'

export type DealStageMoveErrorHandlers = {
  setSelectedDeal: (deal: Deal) => void
  setDealPanelHighlight: (highlight: { dealId: string; fields: string[] }) => void
  toastError: (message: string) => void
}

/** Toast + painel + destaque de campo quando falha mover deal (ex.: reunião sem data). */
export function handleDealStageMoveError(
  err: unknown,
  deal: Deal,
  handlers: DealStageMoveErrorHandlers,
  fallback = 'Erro ao mover deal',
): void {
  const extracted = extractApiError(err, fallback)
  const message = getFriendlyError(err, extracted.message || fallback)

  const highlightFields =
    extracted.highlightFields.length > 0
      ? extracted.highlightFields
      : extracted.code === 'REUNIAO_REQUIRED'
        ? [REUNIAO_REQUIRED_FIELD]
        : []

  if (extracted.code === 'REUNIAO_REQUIRED' || highlightFields.includes(REUNIAO_REQUIRED_FIELD)) {
    handlers.setSelectedDeal(deal)
    handlers.setDealPanelHighlight({ dealId: deal.id, fields: highlightFields })
  }

  handlers.toastError(message)
}
